import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("ZapierLogoSymbol", {
  root: { display: "block" }
});

export { Styles };
//# sourceMappingURL=Styles.es.js.map
